import { render, staticRenderFns } from "./SendEmailDialog.vue?vue&type=template&id=2bd59f79&scoped=true&"
import script from "./SendEmailDialog.vue?vue&type=script&lang=ts&"
export * from "./SendEmailDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SendEmailDialog.vue?vue&type=style&index=0&id=2bd59f79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd59f79",
  null
  
)

export default component.exports